import client from './client';

export const messagingApi = {
  listMessages: (orderId) =>
    client.get(`/messaging/orders/${orderId}/messages/`).then((r) => r.data),
  sendMessage: (orderId, data) =>
    client.post(`/messaging/orders/${orderId}/messages/`, data).then((r) => r.data),
};
